import { css } from '@emotion/react';

export const topPageStyle = css`
  body {
    margin: 0px;
    padding: 0px;
    color: #222222;
  }
`;
